import React from "react";

interface ModalWithImageBackgroundProps {
  open: boolean;
  onClose: () => void;
  text: React.ReactNode;
  buttons?: React.ReactNode;
}

export default function ModalWithImageBackground({ open, onClose, text, buttons }: ModalWithImageBackgroundProps) {

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/30"
      onClick={onClose}
    >
      <div
        className="relative flex flex-col w-[715px] h-[620px] rounded-lg overflow-hidden bg-cover bg-center"
        style={{
          backgroundImage: "url('/images/BG.png')",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="w-full h-[527px] relative">
          <div className="absolute left-[450px] top-72 transform -translate-x-1/2 -translate-y-1/2 bg-white rounded-3xl shadow-lg p-8 min-w-[370px] max-w-[400px] flex flex-col justify-start text-right rtl word-break break-words">
            <div className="w-full">{text}</div>
          </div>
        </div>

        <div className="flex-1 bg-white flex items-center justify-end gap-4 p-4">
          {buttons || (
            <>
              <button
                onClick={onClose}
                className="rounded-xl bg-white text-primaryVar border border-primaryVar px-6 h-10 flex items-center justify-center font-medium transition-all"
              >
                بازگشت
              </button>
              <button
                className="rounded-xl bg-primaryVar text-white px-6 h-10 flex items-center justify-center font-medium hover:bg-primaryVar/80 transition-all disabled:bg-primaryVar/50"
              >
                تایید و ارسال پیام
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};